import React, { useState, useEffect } from "react";
import { db, doc, setDoc, onSnapshot } from "./firebase";
import "./App.css";
import { BsFillPersonCheckFill, BsFillPersonDashFill } from "react-icons/bs";

const STATUS_DOC = "meetingStatus";

const STATUS_STATES = [
  { label: "Available", color: "available", text: "Available - Free to talk" },
  { label: "In a Meeting (Noise Acceptable)", color: "noise-acceptable", text: "In a Meeting - Noise is okay" },
  { label: "In a Meeting (No Noise)", color: "no-noise", text: "In a Meeting - No Noise Allowed" }
];

function App() {
  const [statusIndex, setStatusIndex] = useState(0);

  // Real-time Firestore Sync
  useEffect(() => {
    const unsubscribe = onSnapshot(doc(db, "status", STATUS_DOC), (docSnap) => {
      if (docSnap.exists()) {
        setStatusIndex(docSnap.data().statusIndex ?? 0);
      }
    });

    return () => unsubscribe();
  }, []);

  // Set meeting status
  const setMeetingStatus = async (index) => {
    await setDoc(doc(db, "status", STATUS_DOC), { statusIndex: index });
    setStatusIndex(index);
  };

  // End meeting (reset to available)
  const endMeeting = async () => {
    await setDoc(doc(db, "status", STATUS_DOC), { statusIndex: 0 });
    setStatusIndex(0);
  };

  return (
    <div className="container">
      {/* Meeting Status Box */}
      <div className="status-box">
        <h2>Current Status</h2>
        <p className={`status ${STATUS_STATES[statusIndex]?.color || "available"}`}>
          {STATUS_STATES[statusIndex]?.text || "Available - Free to talk"}
        </p>
      </div>

      {/* Meeting Control Box (for Amy) */}
      <div className="controls-box">
        <h3>Meeting Controls (Amy Only)</h3>

        {statusIndex === 0 ? (
          <div className="button-group">
            <button className="toggle-button noise-acceptable" onClick={() => setMeetingStatus(1)}>
              <BsFillPersonCheckFill size={20} /> Start Meeting (Noise OK)
            </button>
            <button className="toggle-button no-noise" onClick={() => setMeetingStatus(2)}>
              <BsFillPersonDashFill size={20} /> Start Meeting (No Noise)
            </button>
          </div>
        ) : (
          <button className="toggle-button end-meeting" onClick={endMeeting}>
            <BsFillPersonDashFill size={20} /> End Meeting
          </button>
        )}
      </div>
    </div>
  );
}

export default App;
